import httpClient from '@/apis/base/httpclient';
import DashboardApi from './_dashboardApi';

class DashboardUsingIncomeAndExpenseAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Hàm kiểm tra xem báo cáo đã được lập hay chưa
   * @returns
   * pqkhanh 23.06.2023
   */
  async getChartData(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataChart',
      data: param,
    };

    let res = await httpClient.postAsync(request);
    return res;
  }

  getComboboxPaging(payload) {
    let param = { ...payload };
    let request = {
      url: this.getAPIUrl() + '/DataChartArises',
      data: param,
    };
    return httpClient.postAsync(request);
  }
}

export default new DashboardUsingIncomeAndExpenseAPI();
